// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const NotesCell = registerClientReference(
    function() { throw new Error("Attempted to call NotesCell() from the server but NotesCell is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/review-table.tsx",
    "NotesCell",
);
export const PillSelect = registerClientReference(
    function() { throw new Error("Attempted to call PillSelect() from the server but PillSelect is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/review-table.tsx",
    "PillSelect",
);
export const ReviewTable = registerClientReference(
    function() { throw new Error("Attempted to call ReviewTable() from the server but ReviewTable is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/review-table.tsx",
    "ReviewTable",
);
export const StatCard = registerClientReference(
    function() { throw new Error("Attempted to call StatCard() from the server but StatCard is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/review-table.tsx",
    "StatCard",
);
